import { render, staticRenderFns } from "./AlternatePie.vue?vue&type=template&id=e2f994a4&"
import script from "./AlternatePie.vue?vue&type=script&lang=js&"
export * from "./AlternatePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports